import { DialogClose, DialogTitle } from '@radix-ui/react-dialog';
import { CloseOutlined } from '@ant-design/icons';

import { homeUrl } from '@/utils/env';
import { PayDialog, PayDialogUserInfo } from '@/components/pay_ui/pay_dialog';
import { Button } from '@/components/button';
import i18n from '@/locales/init';

interface PayDialogLayoutProps {
  className?:string;
  dialogTitle?:React.ReactNode;
  open:boolean;
  handleClose: () => void;
  userInfo:{
    avatar: string;
    userName: string;
    description: string;
  };
  content?:React.ReactNode;
  contentRight?:React.ReactNode;
}
export const PayDialogLayout = (props:PayDialogLayoutProps)=>{
  const {dialogTitle, content,open,handleClose,userInfo, contentRight, className} = props;
  return <PayDialog open={open} onOpenChange={handleClose} className={`w-full max-w-[min(calc(100%-40px),1018px)] rounded-[20px] bg-[#000437] border-none ${className}`}>
    <DialogTitle className="hidden">{dialogTitle}</DialogTitle>
    <div className="flex flex-col m-[14px]">
      <div className="flex justify-between">
        <PayDialogUserInfo userInfo={userInfo} />
        <div className='flex translate-y-[-10px]'>
          <Button onClick={() => window.open(`${homeUrl}price.html`)} variant={'text_default'} className="text-white">{i18n.t('了解更多权益')}</Button>
          <DialogClose>
            <CloseOutlined className="text-white text-[24px]" />
          </DialogClose>
        </div>
      </div>
      <div className='relative grid bg-white rounded-[20px] leading-[initial] mt-[20px] overflow-hidden min-h-[473px]'>
        <div className='py-[32px] pl-[32px] overflow-hidden' style={{
          width: 'calc(100% - 273px)'
        }}>
          {content}
        </div>

        <div className='absolute bg-white flex flex-col justify-center items-center top-0 right-0 border-l-8 border-[#e5e5e5] h-full w-[273px]'>
          {
            contentRight
          }
        </div>
      </div>
    </div>
  </PayDialog>;
};
